import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppServiceHelperService } from '../../../services/app-service-helper.service';
import { FileDownloadService } from '../../../services/file-download-service.service';

/**
 * Kpi Export Service
 */
@Injectable({
  providedIn: 'root'
})
export class CustomKpiExportService {
  /**
   * Constructor
   * @param httpClient HttpClient
   */
  constructor(private httpClient: HttpClient, private appServiceHelper: AppServiceHelperService, private fileDownloadService: FileDownloadService) { }

  /**
   * Start the custom KPI download
   */
  requestCustomKpiExport() {
    const resource = this.appServiceHelper.getServiceEndpoint('pollux.import.api', 'export/kpi/custom');

    return this.fileDownloadService.initiateDownload(resource, '', false);
  }
}
